<template>
  <!-- 商品库 -->
  <div class="product main-container" :class="{ 'wts-page': $units.isWTS() }">
    <div class="content">
      <div class="search-box">
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable>
            <Option v-for="(bean, i) in companyList" :key="i" :value="bean.companyCode">{{ bean.companyName }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" multiple :max-tag-count="1" clearable>
            <Option value="1">网销产品</Option>
            <Option value="3">经代产品</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">销售状态</span>
          <Select v-model="searchParams.salesStatus" clearable>
            <Option value="1">停售</Option>
            <Option value="2">在售</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">投保地区</span>
          <select-region :requestParams='{"platType":"2"}' requestType='GET' url='/buz/area/orgProductAreaTree' v-model="searchParams.insureAreaCodes" :checkAllData="true" ref="selectRegion"></select-region>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">查询</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" @click="insureUrl('https://partner-h5.txb99.com/#/toolbox/jobTool')" v-if="curTab.name == '团财'">团险职业查询</Button>
        </div>
      </div>

      <div class="main-tabs">
        <ul class="clearfix">
          <li @click="e => toggleMainTabs(e, item, index)" v-for="(item, index) in mainTab" :key="index" :class="{ active: item.active === true }">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="tabs" v-if="mainTabId == 1 && tab.length > 0">
        <ul class="clearfix">
          <li @click="e => toggleTabs(e, item, index)" v-for="(item, index) in tab" :key="index" :class="{ active: item.active === true }" :ref="'li' + index">
            <!-- <span>{{ item.name }}</span> -->
            {{ item.name }}
            <i :class="{ line: item.active === true }"></i>
          </li>
        </ul>
      </div>
      <div class="filterTab">
        <ul class="clearfix">
          <li @click="e => togglefilterTab(item)" v-for="(item, index) in filterTab" :key="index" :class="{ active: item.active === true }">
            {{ item.name }}
          </li>
        </ul>
      </div>
      <div class="filterList" v-if="tableData.length > 0">
        <ul class="clearfix">
          <li v-for="(item, index) in filterList" @click="e => togglefilterList(item)" :class="{ active: item.active === true }">
            <span>{{ item.name }}</span>
            <span class="ivu-table-sort" v-if="index > 0" style="width: 21px">
              <i class="ivu-icon ivu-icon-md-arrow-dropup" :class="{ on: item.iconStatus === 2 }"></i>
              <i class="ivu-icon ivu-icon-md-arrow-dropdown" :class="{ on: item.iconStatus === 1 }"></i>
            </span>
          </li>
        </ul>
        <span class="proNum">
          共<span class="mainColor">{{ total }}</span
          >款产品
        </span>
      </div>
      <div class="list" v-if="tableData.length > 0" v-loading="listLoading">
        <div class="item clearfix" v-for="(item, index) in tableData" :key="index">
          <div class="title">
            <img v-if="item.dockChannel == 2" src="@static/images/smle-logo.png" />
            <span>{{ item.productName }}</span>
            <!-- 预售 -->
            <img v-if="item.preSale == 1" class="icon-selltype" src="@static/images/product/icon_ys.png" />
            <!-- 不可售 -->
            <img v-else-if="item.salesStatus == 1" class="icon-selltype" src="@static/images/product/icon_unsale.png" />
            <template v-if="item.sellType">
              <img v-if="item.sellType.includes('1')" class="icon-selltype" src="@static/images/product/icon_wx.png" />
              <img v-else-if="item.sellType.includes('3')" class="icon-selltype" src="@static/images/product/icon_jd.png" />
            </template>
              
            <template v-if="$units.isWTS() && item.insureType">
              <img v-if="item.insureType.includes('2')" class="icon-selltype" src="@static/images/product/icon_daitou.png">
              <img v-if="item.insureType.includes('4')" class="icon-selltype" src="@static/images/product/icon_yuyue.png">
              <img v-if="item.insureType.includes('5')" class="icon-selltype" src="@static/images/product/icon_shouji.png">
              <img v-if="item.insureType.includes('6')" class="icon-selltype" src="@static/images/product/icon_dingtou.png">
              <img v-if="item.insureType.includes('7')" class="icon-selltype" src="@static/images/product/icon_wailian.png">
            </template>
              <!-- 税优险 -->
            <img v-if="item.shuiYouXian == 1" class="icon-selltype" src="@static/images/product/icon_syx.png" />
            <img v-if="item.publishStatus == 1" class="icon-selltype" src="@static/images/product/icon_status.png" />
          </div>

          <div class="container-item">
            <div class="first">
              <div class="offline-time-box" v-if="item.offlineTime">
                <img class="icon-laba" src="@static/images/product/icon-laba.png" alt="">
                产品将于{{item.offlineTime| filterTime('YYYY年MM月DD日 HH:mm') }}下架</div>
              <div class="descList clearfix" v-if="item.goodness">
                <div class="descItem" v-for="its in item.goodness.replace(/<br>/g, '\n').split(/[\n]/)">
                  <Icon type="ios-checkmark-circle-outline" color="#236dff" size="18" />
                  <span>{{ its }}</span>
                </div>
              </div>
              <div class="other clearfix" v-if="item.feature">
                <div class="otherItem" v-for="its in item.feature.replace(/<br>/g, '\n').split(/[\n]/)">
                  {{ its }}
                </div>
              </div>
              <div class="divide"></div>
            </div>
            <div class="center">
              <div class="fr">
                <div class="tip">保费</div>
                <div class="txt">{{ item.insureCost ? item.insureCost : 0.0 }}元起</div>
              </div>
              <div class="fr server-wrap">
                <div class="tip">服务费</div>
                <div
                  class="serverCon"
                  @click="
                    $router.push({
                      name: 'lookServer',
                      query: {
                        code: item.productCode,
                        type: item.productType,
                        status: item.publishStatus,
                        sourceType: item.sourceType,
                        name: item.productName,
                        iconUrl: item.companyIcon,
                        infoText: item.settlementDescription
                      }
                    })
                  "
                >
                  <div>
                    <span v-if="item.min != item.max">{{ item.min }}%~{{ item.max }}%</span>
                    <span v-else>{{ item.min }}%</span>
                    <Icon type="ios-arrow-forward" color="#ff7134 " size="16" />
                  </div>
                </div>
                <div v-if="item.activityInfoVO" class="serverCon">
                  <span class="timeLimit" v-if="userType != 3">限时加费</span>
                  {{ userType == 3 ? '业务员' : '' }}
                  <span v-if="item.activityInfoVO.commissionNum > 1">最高达</span>
                  {{ item.activityInfoVO.commission }}%
                </div>
                <div v-if="item.activityInfoVO" class="serverCon">
                  {{ item.activityInfoVO.startTime }}<span v-if="item.activityInfoVO.startTime && item.activityInfoVO.endTime">至</span>
                  {{ item.activityInfoVO.endTime }}
                </div>
              </div>
              <div class="fr company-logo">
                <img :src="item.companyIcon" />
              </div>
              <div class="fr resource-wrap">
                <div
                  @click="
                    $router.push({
                      name: 'promotional',
                      query: { productCode: item.productCode, productId: item.id, curNum: '0' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_resource.png" alt="" /><span>文档资料</span>
                </div>
                <div
                  @click="
                    $router.push({
                      name: 'promotional',
                      query: { productCode: item.productCode, productId: item.id, curNum: '1' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_poster.png" alt="" /><span>产品海报</span>
                </div>
                <div
                  v-if="item.productCategory == 3"
                  @click="
                    $router.push({
                      name: 'promotional',
                      query: { productCode: item.productCode, productId: item.id, curNum: '2' }
                    })
                  "
                >
                  <img src="@static/images/product/icon_hzhf.png" alt="" /><span>回执回访指引</span>
                </div>
              </div>
            </div>
            <!-- sourceType 1是平台 2是非平台 3团险-->
            <div class="last" v-if="item.sourceType == 2 || item.sourceType == 3">
              <div class="means-text" @click="insureUrl(item.insureProfileUrl)">投保流程</div>
              <div v-if="item.insureUrl" class="btn link-btn" @click="getInsureUrl(item)">获取投保链接</div>
              <!-- 平台的团险 -->
              <div class="btn link-btn" v-if="item.sourceType == 3" @click="onlineRecording(item)">在线录单</div>
            </div>
            <div class="last" v-else>
              <div class="means-text" @click="insureUrl(item.insureProfileUrl)">投保流程</div>
              <div
                class="btn link-btn"
                v-if="item.insureType.includes('1') || item.insureType.includes('4') || item.insureType.includes('5') || item.insureType.includes('7')"
                @click="getInsureUrl(item)"
              >
                获取投保链接
              </div>
              <div class="btn link-btn" v-if="item.insureType.includes('6')" @click="$refs.directionalPolicy.open(item)">获取投保链接</div>
              <!-- <div
                class="btn link-btn"
                v-else-if="item.isAppointInsure == 1 || item.insureType.includes('4') || item.insureType.includes('5')"
                @click="openPage(item, true)"
              >
                预约投保
              </div> -->
              <div class="btn link-btn" v-else-if="item.insureType.includes('2')" @click="openPage(item, true)">在线录单</div>
            </div>
          </div>
          <div class="bottom-item">
            <p v-if="item.insureAreas && JSON.stringify(item.insureAreas) != '[]'">
              <span>投保地区：</span>
              <span>{{ item.insureAreas.join('，') }}</span>
            </p>
            <p v-if="item.doubleRecordRules && JSON.stringify(item.doubleRecordRules) != '[]'">
              <span>双录规则：</span>
              <span>{{ item.doubleRecordRules.join('，') }}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="wrapper" v-if="tableData.length == 0">
        <div>
          <img src="@static/images/noData.png" alt />
        </div>
        <div>
          <span>暂无产品</span>
        </div>
      </div>
      <div class="pageBox" v-if="tableData.length > 0">
        <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>
    <!-- 定投弹窗 -->
    <directionalPolicy ref="directionalPolicy"></directionalPolicy>
    <!-- 团险选择档次 -->
    <select-grade-modal ref="selectGradeModal"></select-grade-modal>
    <!-- 获取链接 -->
    <get-link-modal ref="getLinkModal"></get-link-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { pageTool } from '@/api/mixins';
import getLinkModal from './components/getLinkModal';
import selectGradeModal from './components/selectGradeModal';
import directionalPolicy from './components/directionalPolicy';
import selectRegion from '@/components/commons/selectRegion';
import { getFirstTag, getSecondTag, mechExportAll } from '@/api/httpList';
export default {
  mixins: [pageTool],
  components: { directionalPolicy, selectGradeModal, getLinkModal, selectRegion },
  props: {},
  data() {
    return {
      pageNo: 1,
      pageSize: 5,
      total: 0,
      companyList: [], //公司列表
      supplierList: [], //供应商列表
      navLeft: 0,
      //首级标签
      mainTab: [
        {
          name: '全部产品',
          active: true,
          value: 1
        },
        {
          name: '活动产品',
          active: false,
          value: 2,
          id: 99
        },
        {
          name: '已停售产品',
          active: false,
          value: 3,
          id: 999
        }
      ],
      //一级标签
      tab: [],
      //二级标签
      filterTab: [],
      //三级标签
      filterList: [
        {
          name: '综合排序',
          active: true,
          value: ''
        },
        {
          name: '销量',
          iconStatus: 0,
          value: 1
        },
        {
          name: '上架时间',
          iconStatus: 0,
          value: 2
        },
        {
          name: '保费',
          iconStatus: 0,
          value: 3
        }
      ],
      tableData: [], //产品列表
      userType: '', //账号类别 1、运营 2、商户 3、下级机构
      mainTabId: 1 //首Tab id
    };
  },
  watch: {
    mainTabId(val) {
      this.filterList = [
        {
          name: '综合排序',
          active: true,
          value: ''
        },
        {
          name: '销量',
          iconStatus: 0,
          value: 1
        },
        {
          name: '上架时间',
          iconStatus: 0,
          value: 2
        },
        {
          name: '保费',
          iconStatus: 0,
          value: 3
        }
      ];
    }
  },
  computed: {
    ...mapState(['userInfo']),
    curTab(){
      const data = this.tab.find(item => item.active);
      return data || {};
    },
  },
  created() {
    this.userType = JSON.parse(localStorage.getItem('userInfo')).userType;
  },
  mounted() {
    this.searchParams.productName = sessionStorage.getItem('productName');
    this.init();
  },
  methods: {
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/list';
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list';
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then(res => {
          this.supplierList = res.data;
        });
      }
    },
    goLinkList(item) {
      if (item.isSalePermission != 1 && item.sourceType == 3) {
        this.$notice.error('暂无该产品销售权限，请联系您的销售支持');
        return;
      }
      this.$router.push({
        name: 'insuranceLink',
        query: {
          productCode: item.productCode,
          isGift: item.isGift,
          insureType: item.insureType
        }
      });
    },
    // 打开外链
    openPage(item, isHelp) {
      if (!item.insureUrl) {
        this.$notice.error('产品链接不存在');
        return;
      }
      // 在线录单的链接格式为/product/app/
      if (isHelp) {
        window.open(item.insureUrl.replace('/product/', '/product/app/'));
      } else {
        window.open(item.insureUrl);
      }
    },
    //平台团险在线录单
    async onlineRecording(item) {
      this.$refs.selectGradeModal.open(item, 'jump');
    },
    // 复制投保链接
    async getInsureUrl(item) {
      if (item.sourceType == 3) {
        //平台团险
        this.$refs.selectGradeModal.open(item, 'copyLink');
      } else if (item.insureUrl) {
        this.$refs.getLinkModal.open(item);
        // this.$units.copyUrl(item.insureUrl);
      }
    },
    exportAll() {
      const params = this.setListParams(JSON.parse(JSON.stringify(this.searchParams)));
      mechExportAll(params).then(res => {
        const fileName = decodeURI(res.headers['content-disposition'].split(';')[1].split('filename=')[1]);
        const blob = new Blob([res.data]); //构造一个blob对象来处理数据
        //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        //IE10以上支持blob但是依然不支持download
        if ('download' in document.createElement('a')) {
          //支持a标签download的浏览器
          const link = document.createElement('a'); //创建a标签
          link.download = fileName; //a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click(); //执行下载
          URL.revokeObjectURL(link.href); //释放url
          document.body.removeChild(link); //释放标签
        } else {
          //其他浏览器
          navigator.msSaveBlob(blob, fileName);
        }
        this.listLoading = false;
      });
    },
    toggleMainTabs(e, info) {
      this.pageNum = 1;
      //主tab切换
      this.mainTab.forEach(item => {
        item.active = false;
      });
      info.active = true;
      this.mainTabId = info.value;
      this.listLoading = true;
      this.navLeft = 0;
      this.initFilter(this.tab);
      this.initFilter(this.filterList);
      this.filterTab = [];
      this.geCompanyList();
      this.getList();
    },
    initFilter(arr) {
      arr.forEach((item, index) => {
        item.active = false;
        if (index == 0) {
          item.active = true;
        }
        if (item.iconStatus) {
          item.iconStatus = 0;
        }
      });
    },
    //切换一级导航栏
    toggleTabs(e, item, index) {
      //点击判断当前是否激活，未激活获取二级导航
      if (!item.active) {
        const dom = e.target;
        if (item.name.length == 2) {
          this.navLeft = dom.offsetLeft + 'px';
        } else if (item.name.length == 3) {
          this.navLeft = dom.offsetLeft + 6 + 'px';
        }

        this.tab.forEach(its => {
          this.$set(its, 'active', false);
        });
        this.$set(item, 'active', true);
        const id = item.id ? item.id : this.tab[1].id;
        if (index == 0) {
          //全部
          this.pageNo = 1;
          this.filterTab = [];
          this.getList();
        } else {
          getSecondTag(id).then(res => {
            //初始化二级过滤列表
            this.filterTab = res.data;
            if (this.filterTab.length > 0) {
              this.filterTab.unshift({
                name: '全部',
                active: true
              });
            }

            this.pageNo = 1;
            this.getList();
          });
        }
      }
    },
    //切换二级导航
    togglefilterTab(item) {
      this.filterTab.forEach(its => {
        this.$set(its, 'active', false);
      });
      this.$set(item, 'active', true);
      this.pageNo = 1;
      this.getList();
    },
    //切换三级导航
    togglefilterList(item) {
      this.filterList.forEach(its => {
        this.$set(its, 'active', false);
        if (its.value != item.value) {
          its.iconStatus = 0;
        }
      });
      if (item.value != '') {
        //切换图标状态
        if (item.iconStatus === 0) {
          item.iconStatus = 1;
        } else if (item.iconStatus === 1) {
          item.iconStatus = 2;
        } else if (item.iconStatus === 2) {
          item.iconStatus = 1;
        }
      }
      this.$set(item, 'active', true);
      this.pageNo = 1;
      this.getList();
    },
    filters() {
      let firstTagID, secondTagID, thirds, sort, indexTab;
      this.listLoading = true;
      if (this.mainTabId == 1) {
        firstTagID = this.tab.find(item => item.active == true)?.id; //一级标签
        if (this.filterTab.find(item => item.active == true)) {
          secondTagID = this.filterTab.find(item => item.active == true)?.id; //二级标签
        }
      } else if (this.mainTabId == 2) {
        firstTagID = 99;
      } else {
        indexTab = 2;
      }
      thirds = this.filterList.find(item => item.active == true); //三级标签
      if (thirds.iconStatus === 1) {
        sort = 2;
      } else if (thirds.iconStatus === 2) {
        sort = 1;
      } else {
        sort = '';
      }
      return {
        firstTagID: firstTagID,
        secondTagID: secondTagID,
        thirds: thirds,
        sort: sort,
        indexTab
      };
    },
    //设置查询参数
    setListParams(params) {
      this.pageSize = 5;
      let obj = this.filters();
      let sellType = params.sellType || [];
      let insureType = params.insureType || [];
      params.sellType = sellType.length > 1 ? sellType.join('|') : sellType.length == 1 ? sellType.join(',') : '';
      params.insureType = insureType.length > 1 ? insureType.join('|') : insureType.length == 1 ? insureType.join(',') : '';
      params.firstTag = obj.firstTagID;
      params.secondTag = obj.secondTagID;
      params.orderCode = obj.thirds.value;
      params.indexTab = obj.indexTab;
      params.sortNo = obj.sort;
      this.listUrl = '/buz/productBase/read/salesman/list';
      return params;
    },
    listCallback(resData) {
      sessionStorage.removeItem('productName');
      sessionStorage.removeItem('productCode');
      resData.data.forEach(item => {
        item.insureType = item.insureType || '';
        if (item.titleLabel) {
          item.titleLabel = item.titleLabel.split(',');
        } else {
          item.titleLabel = [];
        }
      });
    },
    //初始化数据
    init() {
      this.initListAjax('/buz/productBase/read/salesman/list');
      this.geCompanyList();
      //获取一级标签
      getFirstTag().then(res => {
        //初始化一级过滤列表
        this.tab = res.data;
        this.tab.splice(0, 0, { name: '全部', active: true });
      });
    },
    //列表保险公司
    geCompanyList() {
      let url;
      if (this.mainTabId == 2) {
        url = '/buz/actProduct/getCompanyList';
      } else {
        url = '/buz/insuranceCompany/getCompanies';
      }
      this.$http({
        url: url,
        type: 'get'
      }).then(res => {
        this.companyList = res.data;
      });
    },
    insureUrl(url) {
      if (!url) {
        this.$notice.error('该产品暂无投保流程');
        return;
      }
      window.open(url);
    }
  }
};
</script>
<style lang="scss" scoped>
.pointer {
  &:hover {
    cursor: pointer;
  }
}

@import './index.scss';

.timeLimit {
  display: inline-block;
  width: 60px;
  height: 20px;
  background: rgba(255, 240, 234, 0.39);
  border: 1px solid #ffd8c7;
  opacity: 1;
  border-radius: 4px;
  // padding: 0 4px;
  font-size: 12px;
}

.link-btn {
  width: 124px;
  height: 30px;
  background: linear-gradient(to left, #ff8700 0%, #ff7134 100%) !important;
  opacity: 1;
  border-radius: 16px;

  &:hover {
    cursor: pointer;
  }
}
</style>
